<template>
  <Modal
      v-model="_value"
      width="800"
      title="JT808实时监控"
      @on-visible-change="visibleChange"
      ok-text="关闭"
      cancel-text="">
    <Row>
      <Col span="4">车辆:{{tracksIntegrityAnalysis.vehicleInfo.registrationNum}}</Col>
      <Col span="4">终端:{{tracksIntegrityAnalysis.terminalNum}}</Col>
      <Col span="4">经度:{{tracksIntegrityAnalysis.latitude}}</Col>
      <Col span="4">纬度:{{tracksIntegrityAnalysis.longitude}}</Col>
      <Col span="8">地址:{{tracksIntegrityAnalysis.addres}}</Col>
    </Row>
    <Row>
      <div style="height: 600px; width: 100%;">
        <!--<Button size="small" style="margin-bottom: 5px;" @click="onSwitch">切换显示</Button>-->
        <div style="width: 100%; height: 100%;" id="qqmap"></div>
        <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="mapLoadding">
          <Spin size="large"></Spin>
          <h6 style="color:#2d8cf0;margin-top:10px;">正在加载轨迹数据...</h6>
        </div>
      </div>
    </Row>
  </Modal>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import { GPS } from '@/libs/positonUtils'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { explainAlarmSign, explainState, explainDirection } from '@/libs/jt808util'
import { reqReverseGeocoderDetail, reqReverseGeocoder, reqSearchDirection } from '@/libs/baidumaputil'
import { reqSearchPOI, reqSearchPolygon, reqGDReverseGeocoderDetail } from '@/libs/amaputil'

export default {
  name: 'jt808monitoringviewmodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    jt808MonitoringViewterminalNum: null,
    vehicleDymaicManager: {
      require: true
    }
  },
  components: {},
  data () {
    return {

      tracksIntegrityAnalysis: {
        id: null,
        vehicleInfo: {
          registrationNum: null
        },
        terminalNum: null,
        latitude: null,
        longitude: null,
        addres: null
      },

      // 地图
      qqMap: null,
      mapLoadding: false,
      mapDefaultCenter: null,
      markers: []

    }// return
  }, // data
  methods: {
    /**
     * 绘制marker
     */
    putVehicleMarker (realtimeLocationFrame) {
      console.log(realtimeLocationFrame)
      // realtimeLocationFrame.latitude, realtimeLocationFrame.longitude
      this.tracksIntegrityAnalysis.latitude = realtimeLocationFrame.latitude
      this.tracksIntegrityAnalysis.longitude = realtimeLocationFrame.longitude

      let gcpoi = GPS.gcj_encrypt(realtimeLocationFrame.latitude, realtimeLocationFrame.longitude)

      this.qqMap.setCenter(new qq.maps.LatLng(gcpoi.lat, gcpoi.lon))

      // 高德逆地址
      reqGDReverseGeocoderDetail(gcpoi.lat, gcpoi.lon, address => {
        // console.log(address)
        this.tracksIntegrityAnalysis.addres = address.formatted_address
      })

      //  //百度逆地址
      //  reqReverseGeocoderDetail(gcpoi.lat, gcpoi.lon, address => {
      // console.log(address)
      //    this.tracksIntegrityAnalysis.addres = address.formatted_address + address.sematic_description
      //  })

      let LatLng = new qq.maps.LatLng(gcpoi.lat, gcpoi.lon)

      var marker = new qq.maps.Marker({
        position: LatLng,
        map: this.qqMap
      })
      this.markers.push(marker)
      marker.setMap(this.qqMap)
    },

    mapInit () {
      this.mapDefaultCenter = new qq.maps.LatLng(22.596527, 113.277128)
      this.qqMap = new qq.maps.Map(document.getElementById('qqmap'), {
        // 地图的中心地理坐标。
        center: this.mapDefaultCenter,
        zoom: 8
      })
      // let LatLng = new qq.maps.LatLng(22.596527, 113.277128)
      // reqReverseGeocoderDetail(22.596527, 113.277128, address => {
      //   console.log(address)
      //   this.tracksIntegrityAnalysis.latitude = 22.596527
      //   this.tracksIntegrityAnalysis.longitude = 113.277128
      //   this.tracksIntegrityAnalysis.addres = address.formatted_address + address.sematic_description
      // })
      // var marker = new qq.maps.Marker({
      //   position: LatLng,
      //   map: this.qqMap
      // });
      // marker.setMap(this.qqMap)
    },

    visibleChange (val) {
      if (val) {
        // this.clearDraw()
        if (this.markers != null && this.markers.length > 0) {
          for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null)
          }
          this.markers = []
        }

        this.tracksIntegrityAnalysis.vehicleInfo.registrationNum = null
        this.tracksIntegrityAnalysis.latitude = null
        this.tracksIntegrityAnalysis.longitude = null
        this.tracksIntegrityAnalysis.addres = null
        this.tracksIntegrityAnalysis.terminalNum = this._jt808MonitoringViewterminalNum

        store.dispatch('Jt808DeviceServ_GetDetail', {
          params: {
            id: this._initValue
          },
          urlparams: null
        }).then(() => {
          if (store.getters.get_Jt808Device_GetDetailResult) {
            this.putVehicleMarker(store.getters.get_Jt808Device_GetDetailResult)
          }
        }).catch(err => {
          console.log(err)
          this.$Message.error(err)
        })

        // 用主机号获取车辆信息
        store.dispatch('PositioningDeviceInfoServ_GetPage', {
          params: null,
          urlparams: {
            q: genQueryParam('terminalNum', 'EQ', this._jt808MonitoringViewterminalNum)
          }
        }).then(res => {
          console.log(res)

          if (res.data.content != null && res.data.content.length > 0) {
            if (res.data.content[0].vehicleInfoId != null) {
              store.dispatch('VehicleInfoServ_GetDetail', {
                params: {
                  id: res.data.content[0].vehicleInfoId
                },
                urlparams: null
              }).then(() => {
                console.log(store.getters.get_VehicleInfo_GetDetailResult)
                if (store.getters.get_VehicleInfo_GetDetailResult) {
                  if (store.getters.get_VehicleInfo_GetDetailResult.registrationNum != null) {
                    this.tracksIntegrityAnalysis.vehicleInfo.registrationNum = store.getters.get_VehicleInfo_GetDetailResult.registrationNum
                  } else {
                    this.tracksIntegrityAnalysis.vehicleInfo.registrationNum = store.getters.get_VehicleInfo_GetDetailResult.vin
                  }
                }
              }).catch(err => {
                console.log(err)
                this.$Message.error(err)
              })
            }
          }
        }).catch(err => {
          console.log(err)
          this.$Message.error(err)
        })
        //         //用主机号获取车辆信息
        // store.dispatch('PositioningDeviceInfoServ_SearchByName',{
        //   params:{
        //     name:this._initValue
        //   },
        //   urlparams:null
        // }).then(res=>{
        //   console.log(res)
        //
        //   store.dispatch('VehicleInfoServ_GetDetail',{
        //     params: {
        //       id: res.data[0].vehicleInfoId
        //     },
        //     urlparams: null
        //   }).then(()=>{
        //     console.log(store.getters.get_VehicleInfo_GetDetailResult)
        //     if (store.getters.get_VehicleInfo_GetDetailResult) {
        //       this.tracksIntegrityAnalysis.vehicleInfo = store.getters.get_VehicleInfo_GetDetailResult
        //     }
        //     // if (store.getters.get_VehicleInfo_GetDetailResult) {
        //     //   if (store.getters.get_VehicleInfo_GetDetailResult.positioningDeviceInfos) {
        //     //     let list =[]
        //     //     list.push(store.getters.get_VehicleInfo_GetDetailResult)
        //     //     this.vehicleDymaicManager.putVehicleInfo(list)
        //     //     let vehicleInfo = this.vehicleDymaicManager.findVehicleInfoByTerminalNum(store.getters.get_VehicleInfo_GetDetailResult.positioningDeviceInfos[0].terminalNum)
        //     //     let newvehiclelist = []
        //     //     if (vehicleInfo) {
        //     //       newvehiclelist.push(vehicleInfo)
        //     //     }
        //     //     this.vehicleDymaicManager.subscribeDymaicData(newvehiclelist, true)
        //     //   }
        //     // }
        //   }).catch(err=>{
        //     console.log(err)
        //     this.$Message.error(err)
        //   })
        // }).catch(err=>{
        //   console.log(err)
        //   this.$Message.error(err)
        // })
      }
    }
  },

  computed: {
    _value: {
      get () {
        return this.value
      },

      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },

    _initValue: {
      get () {
        return this.initValue
      },

      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _jt808MonitoringViewterminalNum: {
      get () {
        return this.jt808MonitoringViewterminalNum
      },

      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },

  mounted () {
    this.$nextTick(() => {
      this.mapInit()
    })
  }
}
</script>

<style scoped>

</style>
